var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"url":_vm.url,"title":_vm.title,"objects":_vm.objectsParsed,"schema":_vm.schemas[_vm.schema],"totalItems":_vm.count,"fields":_vm.selectedHeaders,"ordering":[],"alias":{
        'status_verbose': 'status',
        'container_type_str': 'Container Type',
        'last_alert_code': 'Last Event',
        'client_code': 'Client Code',
        'carrier_name': 'Carrier',
        'bl_or_booking_number': 'BL / Booking',
        'pol_loc': 'POL',
        'pod_loc': 'POD',
        'etd': 'ETD',
        'atd': 'ATD',
        'dtd': 'DTD',
        'eta': 'ETA',
        'ata': 'ATA',
        'dta': 'DTA',
        'storage_days_at_pol': 'Storage days at POL',
        'storage_days_at_pod': 'Storage days at POD',
        'discrepancy_eta_at_pod': 'DTAcP',
        'discrepancy_eta_at_dlv': 'DTAcD',
        'days_in_tsp': 'DTSP',
        'days_in_tsp_planned': 'DTSP Planned',
        'days_in_pod_planned': 'DPOD Planned',
        'days_in_pol_planned': 'DPOL Planned',
        'created_at': 'Created',
        'sf_data': 'C. Form',
      },"mappers":{'health': _vm.HEALTH},"tooltips":{
        'last_alert_code': 'last_alert_message',
        'sf_data': 'sf_data'
      }}}),_vm._v(" "),_c('pagination',{attrs:{"currentPage":_vm.page,"totalItems":_vm.count,"itemsPerPage":_vm.pageSize},on:{"update:currentPage":function($event){_vm.page=$event},"update:current-page":function($event){_vm.page=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f2a1796","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BiTable.vue
// module id = null
// module chunks = 